import { render, staticRenderFns } from "./SliderSmall.vue?vue&type=template&id=6696cdd8"
import script from "./SliderSmall.vue?vue&type=script&lang=js"
export * from "./SliderSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports